import { ApiKey } from "./entity";
import DtoList from "../../base_classes/dto_list";
import { type JSONData } from "../../base_classes/dto.d";
import { type IApiKeyList } from "./list.gen.d";
import { Pagination } from "../../base_classes/pagination";
import { Query } from "../../base_classes/query";

/// ///////////////////////////////////////////////////////////////////////////////////////////////////
/// WARNING! THIS FILE IS AUTOMATICALLY GENERATED, ANY CHANGES WILL BE LOST ON NEXT GENERATION
/// ///////////////////////////////////////////////////////////////////////////////////////////////////

export class ApiKeyList extends DtoList implements IApiKeyList {
  /// ///////////////////////////////////////
  /// //////// PRIVATE VARIABLES ////////////
  /// ///////////////////////////////////////
  _path = "/api_key";

  /// ///////////////////////////////////////
  /// ///////// PUBLIC VARIABLES ////////////
  /// ///////////////////////////////////////
  list: ApiKey[] = [];
  queriedList: ApiKey[] = [];

  /// ///////////////////////////////////////
  /// ////////////// METHODS ////////////////
  /// ///////////////////////////////////////

  _buildInstance(data: JSONData): ApiKey {
    return new ApiKey([], data);
  }

  override async getAll(
    pathVars?: string | string[] | Record<string, string>,
  ): Promise<ApiKey[]> {
    return (await super.getAll(pathVars)) as ApiKey[];
  }

  override async getPaginated(
    pathVars: string | string[],
    pagination: Pagination,
  ): Promise<{
    items: ApiKey[];
    pagination: Pagination;
  }> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return (await super.getPaginated(pathVars, pagination)) as {
      items: ApiKey[];
      pagination: Pagination;
    };
  }

  override async query(
    queries: Query[],
    pagination?: Pagination,
  ): Promise<{
    items: ApiKey[];
    pagination: Pagination;
  }> {
    return (await super.query(queries, pagination)) as {
      items: ApiKey[];
      pagination: Pagination;
    };
  }

  override async search(
    query: string,
    pagination?: Pagination,
  ): Promise<{
    items: ApiKey[];
    pagination: Pagination;
  }> {
    return (await super.search(query, pagination)) as {
      items: ApiKey[];
      pagination: Pagination;
    };
  }
}
